export const environment = {
  production: false,
  apiBaseUrl: 'https://pacstest-api-admin.uds.slu.se/cgikna/adminportal/1.0.0',
  oidcIssuer: 'https://pacstest-auth.uds.slu.se/realms/adminportal',
  ivJumpOutUrl: 'https://pacstestzfp.uds.slu.se',
  rpaIntegrationHsaIds: ''
};
